import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useTeamTasksFeedback } from "../components/TeamTasksFeedbackProvider";

/**
 * Executa mutações do kanban com feedback amigável e sem derrubar o overlay do CRA.
 */
export function useTeamBoardAction() {
  const { showError, showSuccess } = useTeamTasksFeedback();
  const { t } = useTranslation("teamTasks");

  const run = useCallback(
    async (fn, { context = "generic", successKey } = {}) => {
      try {
        const result = await fn();
        if (successKey) showSuccess(t(successKey));
        return result;
      } catch (err) {
        console.error("[teamTasks]", context, err);
        showError(err, context);
        return null;
      }
    },
    [showError, showSuccess, t]
  );

  return { run, showError, showSuccess };
}
